module.exports = __webpack_public_path__ + "img/circle-add-error.f2dc5862.svg";